import React from "react";

const DEFAULT_ICON =
  "https://imgak.mmtcdn.com/flights/assets/media/dt/listing/sannaata.png";
const DEFAULT_TITLE = "Flights could not be found";
const DEFAULT_SUBTITLE =
  "We could not find flights based on the Source/Destination airport and date entered. Please recheck and try again";

/**
 * Empty-state banner for route/airport FIS listing pages with no flights.
 * Copy and icon come from FIS status API `error.data` when available.
 */
export default function FlightStatusNoFlightsBanner({ errorData, variant = "desktop" }) {
  const title = errorData?.title || DEFAULT_TITLE;
  const subtitle =
    errorData?.subtitle || errorData?.message || errorData?.text || DEFAULT_SUBTITLE;
  const rawIcon =
    variant === "mobile"
      ? errorData?.icon || errorData?.iconD
      : errorData?.iconD || errorData?.icon;
  const iconUrl = (rawIcon || DEFAULT_ICON).replace("{density}", "3x");

  return (
    <div className="fs-no-flights-banner" role="alert">
      <div className="fs-no-flights-banner__card">
        <img
          className="fs-no-flights-banner__icon"
          src={iconUrl}
          alt=""
          aria-hidden="true"
          loading="lazy"
        />
        <h2 className="fs-no-flights-banner__title">{title}</h2>
        <p className="fs-no-flights-banner__subtitle">{subtitle}</p>
      </div>
    </div>
  );
}
